import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createTutorialPlaylistSaga } from "src/store/tutorials/saga";
import { MODULE_KEYS } from "src/store/tutorials/type";
import * as Yup from "yup";

const TutorialPlaylistCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("Tutorials.CreatePlaylist").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        ModuleKey: "",
        Title: "",
        Subtitle: "",
        Order: 0,
        IsActive: true,
        Translates: languages.map((x) => ({
          LanguageId: x.EnumId,
          Title: "",
          Subtitle: "",
        })),
      }}
      onSubmit={(values) => {
        dispatch(
          createTutorialPlaylistSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            body: values,
          })
        );
      }}
      validationSchema={Yup.object().shape({
        ModuleKey: Yup.string().required(t("Validation.Required").toString()),
      })}
      multilanguageinputs={[
        { field: "Title", label: t("Tutorials.Title").toString() },
        { field: "Subtitle", label: t("Tutorials.Subtitle").toString() },
      ]}
      inputs={[
        {
          field: "ModuleKey",
          label: t("Tutorials.ModuleKey").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: MODULE_KEYS },
        },
        { field: "Order", label: t("Tutorials.Order").toString(), type: "number" },
        { field: "IsActive", label: t("Tutorials.IsActive").toString(), type: "switch" },
      ]}
    />
  );
};
export default TutorialPlaylistCreateForm;
